export default "__VITE_ASSET__BrPxBI1W__"